<template>
  <AssessmentsReportPage
    :category="marketAssessmentSubscription"
    :initial-fields="marketAssessmentsInitialFields"
    :product="slug"
    :market-type="marketType"
    :show-latest-report-section="showLatestReportSectionInMarketAssessments"
  />
</template>

<script setup lang="ts">
import AssessmentsReportPage from '~/components/assessments/ReportPage.vue'
import type { TProduct } from '~/src/types/product'
import { MARKET_ASSESSMENTS } from '~/constants/services/constants'
import { computed } from 'vue'
import { MARKET_TYPE } from '~/src/constants/markets'

const marketType = MARKET_TYPE.MARKET_ASSESSMENTS

const props = withDefaults(
  defineProps<{
    marketAssessmentSubscription?: string
    product: TProduct
    showLatestReportSectionInMarketAssessments?: boolean
  }>(),
  {
    marketAssessmentSubscription: '',
    showLatestReportSectionInMarketAssessments: false,
  },
)

const slug = computed(
  () => props.product.categoryReportPricing || props.product.slug,
)
const marketAssessmentsInitialFields = computed(() => [
  MARKET_ASSESSMENTS.slug,
  slug,
])
</script>
